import { GetterTree } from "vuex";
import { RootState } from "@/store/types"
import { UserState } from './types'
import { InfoItem } from "@/common/acl";

export const getters: GetterTree<UserState, RootState> = { 

    getTest(state):string{
        return state.test
    },

 }